import React, { useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { login, clearError } from "../../../redux/actions/userAction";

import { RiArrowGoBackFill } from "react-icons/ri";

import "./login.css";

const Login = () => {
	const userState = useSelector(state => state.user);
	const dispatch = useDispatch();
	const history = useHistory();
	const [loginInfo, setLoginInfo] = useState({ email: "", password: "" });
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		dispatch(clearError());
	}, []);

	useEffect(() => {
		if (userState.validToken) history.push("/");
		if (userState.err) {
			switch (userState.err) {
				case "Authorization denied, Invalid token":
				case "Authorization denied, No token":
					dispatch(clearError());
					break;
				case "Missing field":
					setErrorMessage(`Warning: ${userState.err}`);
					break;
				case "Incorrect password":
					setLoginInfo({ ...loginInfo, password: "" });
					setErrorMessage(`Invalid input: ${userState.err}`);
					break;
				case "User doesn't exist":
					setLoginInfo({ email: "", password: "" });
					setErrorMessage(`Invalid input: ${userState.err}`);
					break;
			}
		}
	}, [userState]);

	return (
		<div className="login-page">
			<input type="submit" className="logout-btn" value="BACK" onClick={() => history.push("/")} />
			<div className="container">
				<form className="form-group input-spacing" onSubmit={e => e.preventDefault()}>
					<h1 className="title mb-5">Chess Live</h1>
					{userState.err === "" ? <div></div> : <div className="warning"> {errorMessage} </div>}
					<input
						type="text"
						name="email"
						placeholder="Email or username"
						className="form-control form-control-sm mb-2 mt-2"
						required
						value={loginInfo.email}
						onChange={e => {
							setLoginInfo({ ...loginInfo, [e.target.name]: e.target.value });
							if (errorMessage) {
								dispatch(clearError());
								setErrorMessage("");
							}
						}}
					/>
					<input
						type="password"
						name="password"
						placeholder="Password"
						className="form-control form-control-sm mb-3"
						required
						value={loginInfo.password}
						onChange={e => {
							setLoginInfo({ ...loginInfo, [e.target.name]: e.target.value });
							if (errorMessage) {
								dispatch(clearError());
								setErrorMessage("");
							}
						}}
					/>

					<input
						type="submit"
						value="Log In"
						id="btn-join"
						className="btn btn-primary btn-fill"
						onClick={() => dispatch(login(loginInfo))}
					/>
					<div className="signup-link">
						Don't have an account? <Link to="/signup"> Sign Up</Link>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Login;
